import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AppTheme = 'light' | 'dark' | 'ocean' | 'pearl' | 'forest' | 'sky' | 'aurora' | 'blueprint' | 'midnight';

const THEME_KEY = 'app_theme_v2';

const getInitialTheme = (): AppTheme => {
  const saved = localStorage.getItem(THEME_KEY);
  const validThemes: AppTheme[] = ['light', 'dark', 'ocean', 'pearl', 'forest', 'sky', 'aurora', 'blueprint', 'midnight'];
  if (saved && validThemes.includes(saved as AppTheme)) {
    return saved as AppTheme;
  }
  return 'light';
};

const themeStore = createSlice({
  name: "theme",
  initialState: {
    theme: getInitialTheme() as AppTheme,
  },
  reducers: {
    setTheme(state, action: PayloadAction<AppTheme>) {
      state.theme = action.payload;
      localStorage.setItem(THEME_KEY, action.payload);
    },
  },
});

export default themeStore;

export const { setTheme } = themeStore.actions;
